import * as React from "react";
import { DetailContainer } from "../common/detail-container";
import {
  DataGrid,
  GridRowData
} from "@material-ui/data-grid";
import SendIcon from "@material-ui/icons/Send";
import RemoveIcon from "@material-ui/icons/RemoveShoppingCart";
import { getStores } from "../../../../sdk/categories";
import { UpdateStoreDelivery } from "../detail-actions/update-store-delivery";
import { ReleaseStore } from "../../../../../../../common/types/release/release-store";
import { Button } from "@material-ui/core";

interface ReleaseDeliveryInstructionsProps {
  releaseId: string;
  releaseStores: ReleaseStore[];
}

export const ReleaseDeliveryInstructions: React.FC<
  ReleaseDeliveryInstructionsProps
> = (props) => {

  const [rows, setRows] = React.useState<GridRowData[]>([]);
  const [open, setOpen] = React.useState(false);
  const [instruction, setInstruction] = React.useState<'redeliver' | 'takedown'>('redeliver');
  const [platforms, setPlatforms] = React.useState<ReleaseStore[]>([]);
  const [stores, setStores] = React.useState<ReleaseStore[]>([]);
  const [selectedIds, setSelectedIds] = React.useState<string[]>([]);

  React.useEffect(() => {
    getStores().then((response) => {
      const gridData: GridRowData[] = [];
      setPlatforms(response.map((s) => s.metadata));
      response.map((s) => {
        const store = s.metadata as ReleaseStore;
        const deliveredStores = props.releaseStores.map((rs) => rs.name);
        const isDelivered = deliveredStores.includes(s.name);
        gridData.push({
          id: store.id,
          dspName: store.name,
          deliveryStatus: isDelivered ? "Delivered": "Not Delivered",
          instruction: isDelivered
        });
      });
      setRows(gridData);
    })
  }, [props]);

  return (
    <DetailContainer style={{ width: "100%" }}>
      <div style={{display: "flex", gap: 10}}>
        <Button 
          style={{background: "green"}} 
          disabled={selectedIds.length === 0} 
          onClick={() => {
            setInstruction('redeliver');
            setStores(platforms.filter((p) => selectedIds.includes(p.id)));
            setOpen(true);
          }}
        >Deliver To Selected DSPs</Button>
        <Button 
          style={{background: "red"}} 
          disabled={selectedIds.length === 0}
          onClick={() => {
            setInstruction('takedown');
            setStores(platforms.filter((p) => selectedIds.includes(p.id)));
            setOpen(true);
          }}
        >Takedown From Selected DSPs</Button>
      </div>
      <DataGrid
        rows={rows}
        columns={[
          { field: 'id', headerName: 'DSP Id', width: 150 },
          { field: 'dspName', headerName: 'DSP Name', width: 300},
          { field: 'deliveryStatus', headerName: 'Delivery Status', width: 200 },
          { 
            field: 'instruction', 
            headerName: ' ', 
            sortable: false, 
            width: 100,
            renderCell: (params) => {
              if (params.value) {
                return (
                  <div onClick={() => {
                    setOpen(true);
                    setInstruction('takedown');
                    setStores(platforms.filter((p) => p.id === params.id));
                  }}>
                    <RemoveIcon style={{color: "red"}} />
                  </div>
                );
              } else {
                return (
                  <div onClick={() => {
                    setOpen(true);
                    setInstruction('redeliver');
                    setStores(platforms.filter((p) => p.id === params.id));
                  }}>
                    <SendIcon style={{color: "green"}} />
                  </div>
                );
              }
            }
          },
        ]}
        checkboxSelection
        autoHeight={true}
        onSelectionModelChange={(params) => {
          console.log(params.selectionModel);
          setSelectedIds(params.selectionModel as string[]);
        }}
      />
      {open && (
        <UpdateStoreDelivery 
          stores={stores} 
          setOpen={setOpen}
          instruction={instruction} 
          isOpen={open} 
          releaseId={props.releaseId} 
        />
      )}
    </DetailContainer>
  );
};
